import {dedupingMixin} from '@polymer/polymer/lib/utils/mixin';

/**
 * @polymer
 * @mixinFunction
 **/
export const ResizeObserverBehavior = dedupingMixin((superClass) => class extends superClass {
  static get properties() {
    return {
      _resizeBehaviorObserverEnabled: {type: Boolean, value: true, observer: '_resizeBehaviorObserverEnabledChanged'},
      _resizeBehaviorObserverInstance: {type: Object}
    };
  }

  connectedCallback() {
    super.connectedCallback();

    if (window.ResizeObserver) {
      this._resizeBehaviorObserverInstance = new ResizeObserver(entries => {
        for (let entry of entries) {
          this.handleElementResized(entry.target, entry.contentRect);
        }
      });
      if (this._resizeBehaviorObserverEnabled) {
        this._resizeBehaviorObserverInstance.observe(this);
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this._resizeBehaviorObserverInstance) {
      this._resizeBehaviorObserverInstance.disconnect();
      this._resizeBehaviorObserverInstance = null;
    }
  }

  _resizeBehaviorObserverEnabledChanged(newValue) {
    if (!this._resizeBehaviorObserverInstance) {
      return;
    }
    if (newValue) {
      this._resizeBehaviorObserverInstance.observe(this);
    } else {
      this._resizeBehaviorObserverInstance.disconnect();
    }
  }

  /**
   * Must be implemented on the parent component.
   */
  handleElementResized() {
    console.warn('%cResize Observer Behavior:', 'background: #fc0; color: #000', 'Method `handleElementResized` not defined.');
  }
});